export enum PartModelConstraintViewType {
  Exceeded = "Exceeded",
  All = "All",
}
